// extracted by mini-css-extract-plugin
export var button = "_id-0";